import React from "react";

const HelpPage = () => (
  <div>
    <h1>HelpPage</h1>
  </div>
);

export default HelpPage;
